if (!customElements.get('bundle-bag-tile')) {
  class BundleBagTile extends HTMLElement {
    constructor() {
      super();
      this.price_object = {
        bundle_discount: null,
        bundle_only_price: null,
        sub_discount: null,
        sub_only_price: null,
        bundle_and_sub_price: null,
      };
    }

    priceRoundUp = (original_price, skio_bundle, use_subscription_logic = false) => {
      this.price_object.bundle_discount = Math.floor(original_price * (Number(skio_bundle.percent_discount_tier[skio_bundle.min_bundle_size]))) / 100;
      this.price_object.bundle_only_price = original_price - this.price_object.bundle_discount;
      this.price_object.sub_discount = use_subscription_logic && skio_bundle.products_in_bag.length > 2 ? 
        Math.ceil(original_price * skio_bundle.subscription_discount_value) / 100 : 
        Math.floor(original_price * skio_bundle.subscription_discount_value) / 100;
      this.price_object.sub_only_price = original_price - this.price_object.sub_discount;
      this.price_object.bundle_and_sub_price = 
        this.price_object.sub_only_price - 
        (Math.ceil(this.price_object.sub_only_price * (Number(skio_bundle.percent_discount_tier[skio_bundle.min_bundle_size]))) / 100);
    }

    priceRoundDown = (original_price, skio_bundle) => {
      this.price_object.bundle_discount = Math.floor(original_price * (Number(skio_bundle.percent_discount_tier[skio_bundle.min_bundle_size]))) / 100;
      this.price_object.bundle_only_price = Math.floor(original_price - this.price_object.bundle_discount) / 100;
      this.price_object.sub_discount = Math.floor(original_price * skio_bundle.subscription_discount_value) / 100;
      this.price_object.sub_only_price = Math.floor(original_price - this.price_object.sub_discount) / 100;
      this.price_object.bundle_and_sub_price = 
        this.price_object.sub_only_price - 
        (Math.floor(this.price_object.sub_only_price * (Number(skio_bundle.percent_discount_tier[skio_bundle.min_bundle_size]))) / 100);
    }

    updatePrice = (show_bundle_discount, show_subscription_discount) => {
      const skio_bundle = this.closest('skio-bundle');
      if (!skio_bundle) return;

      const is_first_bag_tile = Number(this.dataset.removeIndex) + 1 === 1;
      const is_last_bag_tile = Number(this.dataset.removeIndex) + 1 === skio_bundle.products_in_bag.length;
      const price_element = this.querySelector('[data-price-money]');
      const original_price = Number(price_element.dataset.bundleBagTilePrice);

      if (show_subscription_discount) {
        if (is_first_bag_tile) {
          this.priceRoundUp(original_price / 100, skio_bundle, show_subscription_discount);
        } else {
          this.priceRoundDown(original_price, skio_bundle)
        }
      } else {
        if (is_last_bag_tile) {
          this.priceRoundUp(original_price / 100, skio_bundle);
        } else {
          this.priceRoundDown(original_price, skio_bundle)
        }
      }
      
      if (show_bundle_discount) {
        price_element.innerHTML = `
          <div>
            <span class="line-through text-grey60">$${original_price / 100}</span> 
            $${show_subscription_discount ? this.price_object.bundle_and_sub_price.toFixed(2) : this.price_object.bundle_only_price.toFixed(2)}
          </div>`
      } else if (show_subscription_discount) {
        price_element.innerHTML = `
          <div>
            <span class="line-through text-grey60">$${original_price / 100}</span> 
            $${this.price_object.sub_only_price.toFixed(2)}
          </div>`
      } else {
        price_element.innerHTML = `<span class="money">$${original_price / 100}</span>`
      }
    }
    
    connectedCallback() {
      document.addEventListener('update-bag-tile-price', (e) => {
        const { show_bundle_discount, show_subscription_discount } = e.detail;
        
        this.updatePrice(show_bundle_discount, show_subscription_discount)
      });

      const parent_container = this.closest('[data-bag-items]');
      this.updatePrice(parent_container.dataset.showBundleDiscount === 'true', parent_container.dataset.showSubDiscount === 'true')
    }      
  }

  customElements.define('bundle-bag-tile', BundleBagTile);
}